// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_f4-2";
export var aiChatCartContainerExit = "_f4-4";
export var aiChatContainerLarge = "_f4-0";
export var aiChatContainerSmall = "_f4-1";
export var aiChatIcon = "_f4-6";
export var slideInFromRight = "_f4-3";
export var slideOutToRight = "_f4-5";